var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.82031,
    y: 28.25,
    width: 13.0078,
    height: 5.51724,
    rx: 2.75862,
    transform: "rotate(-90 1.82031 28.25)",
    stroke: "#91BDFA",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5313,
    y: 28.25,
    width: 26.1016,
    height: 5.51724,
    rx: 2.75862,
    transform: "rotate(-90 11.5313 28.25)",
    stroke: "#91BDFA",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4844,
    y: 28,
    width: 19.2734,
    height: 5.01724,
    rx: 2.50862,
    transform: "rotate(-90 21.4844 28)",
    fill: "#FB7401",
    stroke: "#FB7401",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard4);
export default __webpack_public_path__ + "static/media/Dashboard4.951f4501cf35c3626326bb2bdaf4aaea.svg";
export { ForwardRef as ReactComponent };